/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZutrittskontrolleProtokollFilterOptionenDto } from '../../models/zutrittskontrolle-protokoll-filter-optionen-dto';

export interface GetZutrittskontrolleProtokollFilterOptionen$Plain$Params {
}

export function getZutrittskontrolleProtokollFilterOptionen$Plain(http: HttpClient, rootUrl: string, params?: GetZutrittskontrolleProtokollFilterOptionen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>> {
  const rb = new RequestBuilder(rootUrl, getZutrittskontrolleProtokollFilterOptionen$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>;
    })
  );
}

getZutrittskontrolleProtokollFilterOptionen$Plain.PATH = '/v1/zutrittskontrolle/protokoll/filter-optionen';
